import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatTokenPrice(pricePerMillion: number): string {
  if (pricePerMillion >= 1) {
    return `$${pricePerMillion.toFixed(2)}/1M`
  } else {
    return `$${(pricePerMillion * 1000).toFixed(2)}/1K`
  }
}
